import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, useAuth } from "../context/AuthContext";
import { Reveal } from "../components/Reveal";

export default function Auth() {
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "register" ? "register" : "login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const next = params.get("next") || "/account";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = mode === "register" ? form : { email: form.email, password: form.password };
      const { data } = await api.post(`/auth/${mode}`, payload);
      setUser(data);
      toast.success(mode === "register" ? "Welcome to Valet Premier." : "Welcome back.");
      navigate(next);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 pt-16" data-testid="auth-page">
      <Reveal className="w-full max-w-md">
        <div className="gold-border-card p-8 sm:p-10">
          <p className="text-xs uppercase tracking-[0.3em] text-amber-400/90 font-mono-gold mb-3 text-center">Members Concierge</p>
          <h1 className="font-display font-bold uppercase text-2xl tracking-tight text-center">
            {mode === "login" ? "Welcome back" : "Join the studio"}
          </h1>
          <div className="mt-6 grid grid-cols-2 rounded-full border border-zinc-800 p-1">
            {["login", "register"].map((m) => (
              <button
                key={m}
                onClick={() => setMode(m)}
                data-testid={`auth-tab-${m}`}
                className={`py-2 rounded-full text-xs uppercase tracking-[0.2em] transition-all ${mode === m ? "gold-foil text-black font-semibold" : "text-zinc-400 hover:text-amber-300"}`}
              >
                {m === "login" ? "Sign In" : "Create Account"}
              </button>
            ))}
          </div>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="auth-form">
            {mode === "register" && (
              <input className="vpd-input" placeholder="Full name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="auth-name-input" />
            )}
            <input className="vpd-input" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="auth-email-input" />
            <input className="vpd-input" type="password" placeholder="Password (min 6 characters)" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="auth-password-input" />
            <button type="submit" disabled={loading} data-testid="auth-submit-button" className="w-full gold-foil text-black font-semibold uppercase tracking-[0.2em] text-xs py-4 rounded-full disabled:opacity-50 hover:scale-[1.01] transition-transform">
              {loading ? "One moment…" : mode === "login" ? "Sign In" : "Create Account"}
            </button>
          </form>
        </div>
      </Reveal>
    </main>
  );
}
